import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Calendar } from "react-date-range";
import { useTranslation } from "react-i18next";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloseIcon from "@mui/icons-material/Close";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./Session.css";
import "./AddSessionDialog.css";
import { currentTimeValue, openNativeTimePicker } from "../utils/sessionNow";

const DURATION_PRESETS = [45, 60, 90, 120];

const Manualsession = ({ open, setopen, handleadd, type, allowPastDates = false }) => {
  const [sessionDuration, setSessionDuration] = useState(90);
  const [time, settime] = useState("");
  const [selectionRange, setSelectionRange] = useState(new Date());
  const timeInputRef = useRef(null);

  const { t } = useTranslation();

  const applyNow = () => {
    const now = new Date();
    setSelectionRange(now);
    settime(currentTimeValue(now));
  };

  useEffect(() => {
    if (!open) {
      setSessionDuration(90);
      settime("");
      setSelectionRange(new Date());
    }
  }, [open]);

  const handleClose = () => setopen(false);

  const handleSubmit = () => {
    if (!time) {
      alert(t("timeRequired") || "Please select a start time");
      return;
    }
    if (!type || !type.te_gen_mode_id) {
      console.error("⚠️ Manualsession - Cannot add session: type or te_gen_mode_id is null");
      return;
    }
    handleadd(
      sessionDuration,
      time,
      selectionRange,
      null,
      null,
      type.te_gen_mode_id
    );
    setSessionDuration(90);
    settime("");
    setSelectionRange(new Date());
    setopen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="manual-session-title"
      slotProps={{
        backdrop: {
          sx: { backgroundColor: "rgba(var(--brand-primary-rgb), 0.35)" },
        },
      }}
    >
      <Box className="asd-modal-box session-add-dialog home-theme-root">
        <div className="asd">
          <header className="asd__header">
            <div className="asd__hero" aria-hidden>
              <EventAvailableOutlinedIcon fontSize="small" />
            </div>
            <div className="asd__header-text">
              <p className="asd__eyebrow">{t("spontaneous") || "Spontaneous"}</p>
              <h2 id="manual-session-title" className="asd__title">
                {t("addsession") || "Add Training Session"}
              </h2>
              <p className="asd__hint">
                {t("spontaneousDescription") ||
                  "Create a single session for a specific date"}
              </p>
            </div>
            <button
              type="button"
              className="asd__close"
              onClick={handleClose}
              aria-label={t("cancel") || "Cancel"}
            >
              <CloseIcon fontSize="small" />
            </button>
          </header>

          <div className="asd__body">
            <section className="asd__section">
              <p className="asd__label">{t("date") || "Date"}</p>
              <div className="asd__field-shell">
                <div className="asd__calendar session-add-dialog__calendar">
                  <Calendar
                    date={selectionRange}
                    onChange={(e) => setSelectionRange(e)}
                    showMonthAndYearPickers={allowPastDates}
                  />
                </div>
              </div>
            </section>

            <div className="asd__row">
              <section className="asd__section">
                <div className="asd__label-row">
                  <label className="asd__label" htmlFor="asd-start-time">
                    {t("starttime") || "Start time"}
                  </label>
                  <button
                    type="button"
                    className="asd__chip asd__chip--now"
                    onClick={applyNow}
                  >
                    {t("now") || "Now"}
                  </button>
                </div>
                <div className="asd__time-controls">
                  <input
                    id="asd-start-time"
                    ref={timeInputRef}
                    className="asd__input asd__input--time"
                    type="time"
                    value={time}
                    onChange={(e) => settime(e.target.value)}
                    step={300}
                    required
                  />
                  <button
                    type="button"
                    className="asd__clock-btn"
                    onClick={() => openNativeTimePicker(timeInputRef.current)}
                    aria-label={t("openTimePicker") || "Open time picker"}
                    title={t("openTimePicker") || "Open time picker"}
                  >
                    <AccessTimeIcon fontSize="small" />
                  </button>
                </div>
              </section>

              <section className="asd__section">
                <label className="asd__label" htmlFor="asd-duration">
                  {t("duration") || "Duration"} ({t("min") || "min"})
                </label>
                <input
                  id="asd-duration"
                  className="asd__input"
                  type="number"
                  min={1}
                  value={sessionDuration}
                  onChange={(e) => setSessionDuration(e.target.value)}
                />
              </section>
            </div>

            <section className="asd__section">
              <p className="asd__label">{t("quickDuration") || "Quick pick"}</p>
              <div className="asd__duration-chips" role="group">
                {DURATION_PRESETS.map((mins) => (
                  <button
                    key={mins}
                    type="button"
                    className={`asd__chip${
                      Number(sessionDuration) === mins ? " is-active" : ""
                    }`}
                    onClick={() => setSessionDuration(mins)}
                  >
                    {mins} {t("min") || "min"}
                  </button>
                ))}
              </div>
            </section>
          </div>

          <div className="asd__actions">
            <button type="button" className="asd__btn asd__btn--ghost" onClick={handleClose}>
              {t("cancel") || "Cancel"}
            </button>
            <button type="button" className="asd__btn asd__btn--primary" onClick={handleSubmit}>
              {t("addsession") || "Add session"}
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default Manualsession;
